// Function to populate hidden input fields from localStorage 
function populateInputs() {
  console.log('in populate inputs');
  const inputs = document.querySelectorAll('.form-17sq__inputs input[type="hidden"]');

  inputs.forEach((input) => {
    const hiddenValue = input.getAttribute('data-value');
    console.log('hiddenValue:', hiddenValue);

    const utmData = JSON.parse(localStorage.getItem('utmData'));

    // Special handling for landing_page
    if (hiddenValue === 'landing_page') {
      try {
        if (utmData?.referrer) {
          input.value = utmData.referrer;
        }
      } catch (e) {
        console.warn('Failed to parse utmData from localStorage:', e);
      }
    }

    // Special handling for device
    else if (hiddenValue === 'device') {

      const isMobile = /Mobi|Android/i.test(navigator.userAgent);
      input.value = isMobile ? 'mobile' : 'desktop';
    }

    // Special handling for ab_tests
    else if (hiddenValue === 'ab_tests') {

      if (window.igData) {
        try {
          const experiments = window.igData?.user.getExperiments();
          if (experiments.length > 0) {
            var abtData = "";
            experiments.forEach(experiment => {
              try {
                var abtVariant = window.igData?.user.getTestGroup(experiment.id);
                abtData = abtData + experiment.name + " : " + abtVariant.name + "; ";
              } catch (err) {
                console.error("Error processing experiment:", err);
              }
            });
            input.value = abtData;
          }
        } catch (error) {
          console.error("Error retrieving Intelligems experiments:", error);
        }
      } else {
        console.warn("Intelligems API not available");
      }
    }

    // Otherwise, use localStorage value
    else {
      const stored = localStorage.getItem(hiddenValue);
      if (stored !== null) {
        try {
          input.value = JSON.parse(stored); // if stored as JSON
        } catch {
          input.value = stored; // fallback to raw string
        }
      }
    }
  });
}

// Poll for dynamically inserted input elements
const interval = setInterval(() => {
  if (document.querySelector('input[name]')) {
    populateInputs();
    clearInterval(interval);
  }
}, 100);

// when form is submitted
function formSubmitted(event) {
  // validate that all requuired fields have values
  event.preventDefault();
  const form = event.target;

  const emailInput = form.querySelector('input[type="email"]');
  const firstNameInput = form.querySelector('input[name="First Name"]');
  const lastNameInput = form.querySelector('input[name="Last Name"]');
  if (emailInput.value == "" || firstNameInput.value == "" || lastNameInput.value == "") {
    // add error alert here
    showFormError("Please fill in all required fields.");
    return false;
  }

  form.querySelector('.form-17sq__submit').style.display = 'none';

  // add captcha and submit
  const formElement = document.getElementById("17sqForm");
  if (formElement.querySelector('#recaptcha-score') != null) {
    formElement.querySelector(".form-17sq__submit").style.display = 'none'
    getRecaptchaAndSubmit(submitMobile17SQForm)
  } else {
    submitMultipleStepForm(formElement)
  }
  return false;
}

function submitMobile17SQForm() {
  console.log("Form submitted, hiding form and showing iframe");
  const iframe = document.getElementById("hidden_iframe");
  const form = document.getElementById("17sqForm");

  const redirectBase = form.dataset.redirect;

  // When the iframe finishes loading after form submission, redirect to tool page 
  iframe.onload = function () {
    if (!redirectBase) return;
    window.location.href = redirectBase;
  };

  form.submit();
}

function showFormError(message) {
  const errorBox = document.getElementById("form-error-message");
  if (!errorBox) return;

  errorBox.textContent = message;
  errorBox.style.display = "block";
}

